<template>
    <div class="publishModal-container">
        <div class="publishModal-mask"></div>
        <div class="publishModal-box">
            <div class="publishModal-topbar">
                <p>发布</p>
                <img class="publishModal-close" :src="closeImg" @click="close()" alt="" />
                <div class="publishModal-tips-box" v-if="showTips">
                    <p>{{ tipContent }}</p>
                </div>
            </div>

            <p class="publishModal-text">您可以选择您所绘制的文件发布至模板社区，供用户学习交流，并可以设置价格，从而获取一定的报酬</p>

            <div class="publishModal-selected">
                <p class="publishModal-selected-title">选择文件：</p>
                <p class="publishModal-selected-file" :style="{ color: activeFile == -1 ? '#00000080' : '#626262' }">{{ selectFile }}</p>
            </div>

            <div class="publishModal-filebox">
                <PublishTreeNode
                    :treeData="publishFileList"
                    :activeFolder="-1"
                    :activeFile="activeFile"
                    :clickFile="clickFile"
                    :clickFold="clickFold"
                />
            </div>

            <div class="publishModal-btnbox">
                <div class="publishModal-btn publishModal-confirm" :class="{ ban: fileStatus == 'none' }" @click="confirm()">下一步</div>
                <div class="publishModal-btn publishModal-cancel" @click="close()">取消</div>
            </div>
        </div>
    </div>
</template>

<script>
    import PublishTreeNode from "./publishTreeNode.vue";
    import { encodePrefix } from "@/public/utils/tool";
    export default {
        name: "publishModal",
        data() {
            return {
                selectFile: "请选择文件",
                activeFile: -1,
                showTips: false,
                fileKey: "",
                fileStatus: "none",
                tipContent: "请选择文件",
                closeImg: require("@/home/parts/publishModal/publish-close.png"),
                isEditFile: true,
            };
        },
        components: {
            PublishTreeNode,
        },
        computed: {
            userInfo() {
                return this.$store.state.userInfo;
            },
            publishFileList() {
                return this.$store.state.publishFileList;
            },
            albumID() {
                return this.$store.state.tplCenter.activeAlbumID;
            },
        },
        methods: {
            resetData() {
                this.showTips = false;
                this.fileStatus = "none";
                this.fileKey = "";
                this.selectFile = "请选择文件";
            },
            close() {
                this.$store.commit("setState", {
                    type: "showPublish",
                    data: false,
                });
                this.resetData();
            },
            init() {
                this.$edApi
                    .getFileForPublishModal({
                        id: this.userInfo.user_id,
                        token: this.userInfo.token,
                    })
                    .then((e) => {
                        let list = [
                                {
                                    type: "folder",
                                    status: true,
                                    name: "个人云",
                                    child: [],
                                },
                            ],
                            files = e.fileList,
                            folders = e.folderList;
                        for (let i = 0; i < folders.length; i++) {
                            let prefixList = folders[i].prefix.split("/");
                            let name = prefixList[prefixList.length - 2];
                            let obj = {
                                type: "folder",
                                status: false,
                                isDownload: false,
                                name: name,
                                prefix: prefixList.slice(2).join("/"),
                                child: [],
                            };
                            list[0].child.push(obj);
                        }
                        for (let file of files) {
                            let obj = {
                                type: "file",
                                id: file.id,
                                name: file.name,
                                key: file.key,
                                time: file.updateTime,
                                publish: file.publish,
                                locked: file.locked,
                                edit: file.edit,
                            };
                            if (this.isPC && !obj.edit) {
                                continue;
                            } else {
                                list[0].child.push(obj);
                            }
                        }
                        this.$store.commit("setState", {
                            type: "publishFileList",
                            data: list,
                        });
                    });
            },
            openFile(key) {
                if (this.isPC) {
                    let pcLockStatus = this.$store.state.pcLockStatus;
                    if (pcLockStatus) {
                        return;
                    }
                    this.$store.commit("setPcLockStatus", true);

                    let userP = this.$store.getters.apiParam;
                    let filePath = key.match(/[^\/]+\/[^\/]+\/(.+)/) && key.match(/[^\/]+\/[^\/]+\/(.+)/)[1];
                    let params = Object.assign({ obj: filePath }, userP);
                    this.$edApi
                        .getDownFileAddress(params)
                        .then((signInfo) => {
                            let obj = key;
                            //中文站用的oss，英文站用的aws，通过getSignature得到的数据不一样
                            let paramForPc;
                            if (this.internal) {
                                let { sign, exp } = signInfo.data;
                                sign = encodeURIComponent(sign);
                                paramForPc = {
                                    fileName: this.selectFile,
                                    sign,
                                    exp,
                                    obj,
                                    type: "open",
                                    action: "publish",
                                    accessid: this.OSSAccessKeyId,
                                };
                                if (this.albumID != -1) {
                                    paramForPc.album = this.albumID;
                                }
                            } else {
                                let { path, query } = signInfo.data;
                                paramForPc = {
                                    fileName: this.selectFile,
                                    path,
                                    query,
                                    type: "open",
                                    action: "publish",
                                    accessid: this.OSSAccessKeyId,
                                };
                            }
                            window.$qt.jsCallCloudFileOperate(JSON.stringify(paramForPc));
                            window.$qt.jsCallUploadData &&
                                window.$qt.jsCallUploadData(
                                    JSON.stringify({
                                        type: "Open",
                                        action: "personalCloud",
                                    })
                                );
                        })
                        .catch(() => {
                            this.$store.commit("setPcLockStatus", false);
                            this.$edMessage.warning(this.$t("networkError"));
                        });
                } else {
                    if (!this.isEditFile) {
                        key += "&preview=1";
                    }
                    let url =
                        window.location.origin +
                        this.$router.options.base +
                        "app.html?" +
                        this.$zipFileName("obj=" + key) +
                        "#publish" +
                        (this.albumID == -1 ? "" : this.albumID);
                    console.log(url);
                    if (this.openInTabs) {
                        location.href = url;
                    } else {
                        window.openPlus(url, key);
                    }
                }
            },
            clickFile(fileItem) {
                console.log(fileItem);
                this.showTips = false;
                this.selectFile = fileItem.name;
                this.activeFile = fileItem.id;
                this.fileKey = fileItem.key;
                this.fileStatus = fileItem.publish;
                this.tipContent = fileItem.publish == "pending" ? "文件审核中，请选择其他文件" : "文件已发布，请选择其他文件";
                this.isEditFile = fileItem.edit;
                if (fileItem.locked) {
                    this.fileStatus = "locked";
                    this.tipContent = $t("lockedFile");
                }
            },
            findFold(arr, prefix, data) {
                if (arr.length == 0) return;
                for (let i = 0; i < arr.length; i++) {
                    let target = arr[i];
                    if (target.type == "folder") {
                        if (target.prefix == prefix) {
                            target.child = data;
                            target.status = true;
                            target.isDownload = true;
                            return;
                        } else {
                            this.findFold(target.child, prefix, data);
                        }
                    }
                }
            },
            clickFold(foldItem) {
                console.log(foldItem);
                if (foldItem.name == "个人云") return;
                if (foldItem.child.length == 0 && !foldItem.isDownload) {
                    console.log(foldItem.prefix);
                    this.$edApi
                        .getFolderForPublishModal({
                            id: this.userInfo.user_id,
                            token: this.userInfo.token,
                            prefix: encodePrefix(foldItem.prefix),
                        })
                        .then((e) => {
                            let list = JSON.parse(JSON.stringify(this.publishFileList)),
                                files = e.fileList,
                                folders = e.folderList,
                                dataList = [];
                            for (let i = 0; i < folders.length; i++) {
                                let prefixList = folders[i].prefix.split("/");
                                let name = prefixList[prefixList.length - 2];
                                let obj = {
                                    type: "folder",
                                    status: false,
                                    name: name,
                                    prefix: prefixList.slice(2).join("/"),
                                    child: [],
                                };
                                dataList.push(obj);
                            }
                            for (let file of files) {
                                let obj = {
                                    type: "file",
                                    id: file.id,
                                    name: file.name,
                                    key: file.key,
                                    time: file.updateTime,
                                    publish: file.publish,
                                    edit: file.edit,
                                };
                                if (this.isPC && !obj.edit) {
                                    continue;
                                } else {
                                    dataList.push(obj);
                                }
                            }
                            this.findFold(list, foldItem.prefix, dataList);
                            this.$store.commit("setState", {
                                type: "publishFileList",
                                data: list,
                            });
                        });
                } else {
                    this.$store.commit("changePublishFolderStatus", foldItem.prefix);
                }
            },
            confirm() {
                console.log(this.fileStatus);
                if (["none", "pending", "pass", "locked"].includes(this.fileStatus)) {
                    this.showTips = true;
                    return;
                }
                this.openFile(this.fileKey);
                this.close();
            },
        },
        mounted() {
            this.init();
        },
    };
</script>

<style lang="stylus">
    .publishModal-container
        position fixed
        left 0
        top 0
        z-index 100
        .publishModal-mask
            position fixed
            left 0
            top 0
            width 100vw
            height 100vh
            background rgba(0,0,0,.4)
            z-index 1
        .publishModal-box
            position fixed
            left 0
            right 0
            top 0
            bottom 0
            margin auto
            width 540px
            height 475px
            background #ffffff
            border-radius 6px
            box-shadow 0px 2px 20px rgba(0, 0, 0, 0.2)
            z-index 2
            .publishModal-topbar
                height 46px
                width 100%
                padding 15px
                padding-bottom 5px
                >p
                    font-size 18px
                    color #626262
                .publishModal-close
                    position absolute
                    right -40px
                    top -4px
                    cursor pointer
                .publishModal-tips-box
                    position absolute
                    left 0
                    right 0
                    top 0
                    margin 0 auto
                    text-align center
                    p
                        display inline-block
                        height 28px
                        background #FCB42A
                        font-size 12px
                        line-height 28px
                        padding 0 10px
                        color #fff
                        max-width 70%
                        overflow hidden
                        text-overflow ellipsis
                        white-space nowrap
                        border-bottom-left-radius 2px
                        border-bottom-right-radius 2px
            .publishModal-text
                padding 0 15px
                margin-bottom 10px
                color #00000080
            .publishModal-selected
                display flex
                align-items center
                margin 0 auto
                width 510px
                height 30px
                p
                    font-size 12px
                    color #626262
                .publishModal-selected-title
                    margin 0 10px 0 0
                    font-weight 700
            .publishModal-filebox
                margin 10px 15px 0 15px
                width 510px
                height 285px
                background #f5f5f5
                overflow auto
                .publishModal-tree
                    padding-left 10px
                    margin-top 5px
                    position relative
                    width 100%
                    .publishModal-tree-node
                        display flex
                        flex-wrap wrap
                        padding 3px 5px
                        >p
                            width calc(100% - 24px)
                            font-size 12px
                            height 24px
                            line-height 24px
                            text-indent 8px
                            user-select none
                            cursor pointer
                            overflow hidden
                            text-overflow ellipsis
                            white-space nowrap
                    .publishModal-tree-folder
                        position relative
                        img
                            width 24px
                        .publishModal-tree-arrow
                            position absolute
                            left -8px
                            top 9px
                            width 12px
                            height 12px
                            transform rotate(-90deg)
                        .publishModal-tree-arrow-openFolder
                            transform rotate(0deg)
                    .publishModal-tree-file
                        position relative
                        img
                            width 21px
                        .item-icon
                            position absolute
                            left 17px
                            top -3px
                            display flex
                            justify-content space-around
                            align-items center
                            width 12px
                            height 12px
                            border-radius 50%
                            border 1px solid #017fff
                            fill #017fff
                            background #fff
                        .pending
                            border-color #f90
                            fill #f90
                    .highlight
                        background #e5e5e5
            .publishModal-btnbox
                position absolute
                right 15px
                margin-top 15px
                display flex
                .publishModal-btn
                    width 75px
                    height 28px
                    text-align center
                    line-height 28px
                    font-size 12px
                    border-radius 2px
                    cursor pointer
                    user-select none
                    transition background .2s linear
                .publishModal-confirm
                    margin-right 10px
                    background #367FF7
                    color #fff
                    &:hover
                        background #367ff7cc
                    &.ban
                        opacity .4
                        cursor not-allowed
                .publishModal-cancel
                    background #d5d7db
                    color #626262
                    &:hover
                        background #d5d7dbcc
</style>
<i18n>
{
  "zh": {
    "lockedFile": "文件已加密，请解密后再分享文件"
  },
  "de": {
    "lockedFile": "Die Datei ist verschlüsselt. Bitte entschlüsseln Sie sie vor dem Teilen"
  },
  "en": {
    "lockedFile": "The file is encrypted, please decrypt it before sharing"
  },
  "es": {
    "lockedFile": "El archivo está cifrado, descifrelo antes de compartirlo"
  },
  "pt": {
    "lockedFile": "O arquivo está criptografado, descriptografe-o antes de compartilhar"
  },
  "it": {
    "lockedFile": "Il file è crittografato, decrittalo prima di condividerlo"
  },
  "jp": {
    "lockedFile": "ファイルは暗号化されています。ファイルを共有する前に復号化してください。"
  },
  "fr": {
    "lockedFile": "Le fichier est chiffré, veuillez le déchiffrer avant de le partager"
  },
  "tw": {
    "lockedFile": "檔案已加密，請解密後再分享檔案"
  },
  "kr": {
    "lockedFile": "파일이 암호화되어 있습니다. 공유하기 전에 해독하십시오."
  },
  "id": {
    "lockedFile": "File dienkripsi. Dekripsikan file sebelum dibagikan"
  }
}
</i18n>
